// Per Mudassir (June): JobPosting / JobApplicant responses now expose skills as
// two separate arrays of skill names — `requiredSkills` (from the Job Title) and
// `additionalSkills` (recruiter-added extras). The legacy combined `skills`
// array is still returned for now but is being deprecated.
//
// Prefer the new split fields and fall back to the legacy `skills` so the UI
// keeps working through the transition AND after `skills` is removed.
//
// Note: all three are arrays of names (strings), not { id, name } objects.
export const getPostingSkills = (job) => {
  if (!job) return [];
  const required = Array.isArray(job.requiredSkills) ? job.requiredSkills : [];
  const additional = Array.isArray(job.additionalSkills) ? job.additionalSkills : [];
  if (required.length || additional.length) return [...required, ...additional];
  return Array.isArray(job.skills) ? job.skills : [];
};
